import { HomeAreaSelectContent } from './HomeAreaSelectContent';
export default HomeAreaSelectContent;